import bg from "./bg.json";
import cs from "./cs.json";
import da from "./da.json";
import de from "./de.json";
import el from "./el.json";
import enGB from "./en-gb.json";
import es from "./es.json";
import et from "./et.json";
import fi from "./fi.json";
import fr from "./fr.json";
import hu from "./hu.json";
import it from "./it.json";
import ja from "./ja.json";
import lt from "./lt.json";
import lv from "./lv.json";
import nl from "./nl.json";
import pl from "./pl.json";
import pt from "./pt.json";
import ptBR from "./pt-br.json";
import ptPT from "./pt-pt.json";
import ro from "./ro.json";
import ru from "./ru.json";
import sk from "./sk.json";
import sl from "./sl.json";
import sv from "./sv.json";
import zh from "./zh.json";
import zn from "./zn.json";
import en from "./zn.json";

const translations = {
  en,
  es,
  fr,
  pt,
  "pt-pt": ptPT,
  "pt-br": ptBR,
  de,
  it,
  nl,
  pl,
  ru,
  ja,
  zn,
  bg,
  cs,
  da,
  el,
  hu,
  lt,
  lv,
  ro,
  sk,
  sl,
  sv,
  fi,
  et,
  zh,
  "en-gb": enGB,
};

export default translations;
